// extracted by mini-css-extract-plugin
module.exports = {"navigationSpacer":"MyLayout_navigationSpacer__DU_L_","ribbonActive":"MyLayout_ribbonActive__6Whdf","blurContainer":"MyLayout_blurContainer__RPQTX","blur":"MyLayout_blur__oh2Hz"};